import { FC } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Text } from 'entities/Text'

type MFACodeProps = {
  submitMFA: (mfa: string) => void
}

export const MFACode: FC<MFACodeProps> = ({ submitMFA }) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    const mfa = data.get('mfa') || ''
    submitMFA(mfa as string)
  }

  return (
    <>
      <Text component='h1' variant='h5'>
        MFA Code
      </Text>
      <Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          autoFocus
          margin='normal'
          required
          fullWidth
          name='mfa'
          label='MFA Code'
          id='mfa'
        />
        <Button type='submit' color='warning' fullWidth variant='contained' sx={{ mt: 3, mb: 2 }}>
          Sumbit
        </Button>
      </Box>
    </>
  )
}
